import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ToolkitStore } from '@reduxjs/toolkit/dist/configureStore';
import { AppStore, Protocol, RecordList } from '../types';
import { apiGetProtocolList } from '../api';

// 请求成功时传送的参数
interface SuccessParams {
  list: Array<Protocol>;
}
// 请求失败时传送的参数
interface FailureParams {
  error: string;
}

const protocolSlice = createSlice({
  name: 'protocol',
  initialState: { fetching: false, loaded: false } as RecordList<Protocol>,
  reducers: {
    protocolRequest: (state: RecordList<Protocol>, action: PayloadAction) => {
      state.fetching = true;
      return state;
    },
    protocolSuccess: (state: RecordList<Protocol>, action: PayloadAction<SuccessParams>) => {
      state.fetching = false;
      state.loaded = true;
      state.results = action.payload.list;
      return state;
    },
    protocolFailure: (state: RecordList<Protocol>, action: PayloadAction<FailureParams>) => {
      state.fetching = false;
      state.loaded = true;
      state.error = action.payload.error;
      return state;
    },
    protocolClear: (state: RecordList<Protocol>) => {
      state = { fetching: false, loaded: false } as RecordList<Protocol>;
      return state;
    },
  },
});

export const { protocolRequest, protocolSuccess, protocolFailure, protocolClear } = protocolSlice.actions;
export default protocolSlice.reducer;

export const protocolEffect = {
  'protocol/clear': (store: ToolkitStore<AppStore>) => store.dispatch(protocolClear()),
  'protocol/protocolRequest': async (store: ToolkitStore<AppStore>, action: PayloadAction) => {
    try {
      let res = await apiGetProtocolList();
      let data = res.data;
      if (data.code === 200) {
        store.dispatch(protocolSuccess({ list: data.data }));
      } else {
        store.dispatch(protocolFailure({ error: data.msg || '获取失败' }));
      }
    } catch (e: any) {
      store.dispatch(protocolFailure({ error: e.toString() || '获取失败' }));
    }
  },
};
